import { config } from './config';
import axios from "axios";

export const tyrionUrlRotationRouteHashesService = {
    post,
    config
};

function post(params){

    let endpoint = '/api/proxy/tyrion/urlrotation/route-hashes/';

    return new Promise((resolve, reject) => {
      axios
        .post(`${config.apiUrl}${endpoint}`, params)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}
